import { useTestError } from './test-error.hooks';

const TestError = ({ name }) => {
  useTestError(name);

  return null;
};

export default TestError;
